/**
 * Unity Event 선언
 * call
 * GetUserSE : 유니티 앱에서 member_se를 가져온다.
 * GetEventSE : 유니티 앱에서 event_se를 가져온다.
 * BackToEvent : 유니티 앱 웹뷰의 종료버튼 함수이다.
 */
export function initUnity() {
	if (
		window &&
		window.webkit &&
		window.webkit.messageHandlers &&
		window.webkit.messageHandlers.unityControl
	) {
		// iOS
		window.Unity = {
			call: function (msg) {
				window.webkit.messageHandlers.unityControl.postMessage(msg);
			},
			GetUserSE: function () {
				window.webkit.messageHandlers.unityControl.postMessage('getuserse');
			},
			GetEventSE: function () {
				window.webkit.messageHandlers.unityControl.postMessage('geteventse');
			},
			BackToEvent: function () {
				window.webkit.messageHandlers.unityControl.postMessage('backtoevent');
			},
			GoToFactory: function () {
				window.webkit.messageHandlers.unityControl.postMessage('gotofactory');
			},
			GoToFortune: function () {
				window.webkit.messageHandlers.unityControl.postMessage('gotofortune');
			},
			MixPanelClickEventButton: function (event_nm, event_category) {
				window.webkit.messageHandlers.unityControl.postMessage(
					`MixPanel=click_event_button?event_name:${event_nm}/source:${event_category}`
				);
			},
			MixPanelCompleteEvent: function (event_nm, event_category, reward_nm) {
				window.webkit.messageHandlers.unityControl.postMessage(
					`MixPanel=complete_event?event_product:${reward_nm}/event_name:${event_nm}/source:${event_category}`
				);
			},
			GoToGameLand: function () {
				window.webkit.messageHandlers.unityControl.postMessage('gotogameland');
			},
			GoToTicket: function () {
				window.webkit.messageHandlers.unityControl.postMessage('gototicket');
			},
		};
	} else {
		// AOS
		window.Unity = {
			call: function (msg) {
				window.location = 'unity:' + msg;
			},
			GetUserSE: function () {
				window.location = 'unity:getuserse';
			},
			GetEventSE: function () {
				window.location = 'unity:geteventse';
			},
			BackToEvent: function () {
				window.location = 'unity:backtoevent';
			},
			GoToFactory: function () {
				window.location = 'unity:gotofactory';
			},
			GoToFortune: function () {
				window.location = 'unity:gotofortune';
			},
			MixPanelClickEventButton: function (event_nm, event_category) {
				window.location = `unity:MixPanel=click_event_button?event_name:${event_nm}/source:${event_category}`;
			},
			MixPanelCompleteEvent: function (event_nm, event_category, reward_nm) {
				window.location = `unity:MixPanel=complete_event?event_product:${reward_nm}/event_name:${event_nm}/source:${event_category}`;
			},
			GoToGameLand: function () {
				window.location = 'unity:gotogameland';
			},
			GoToTicket: function () {
				window.location = 'unity:gototicket';
			},
		};
	}
}

/**
 * 유니티 웹뷰 실행 시 callback 함수에 member_se를 전달해준다.
 * @param {*} callback setMember 콜백함수
 * @param {*} error 에러메시지 alert 창 콜백함수
 * @param {*} delay interval delay 시간
 */
export function setUnityMember(callback, error, delay = 1000) {
	let count = 0;

	const interval = setInterval(() => {
		count += 1;
		const member_se = Number(window.GetMemberSE());
		if (member_se > 0 || count >= 5) {
			callback(member_se);
			clearInterval(interval);

			if (member_se === 0) {
				const message =
					'유저 정보를 불러오지 못했습니다. 이벤트 재접속을 부탁드립니다.';
				error(message);
			}
		}
	}, delay);
}
